import React, { useState, useEffect, useContext } from 'react';
import { FaUser, FaMobileAlt, FaLock, FaArrowRight, FaChevronRight, FaStore } from 'react-icons/fa';
import { Modal } from 'react-bootstrap';
import { isValidPkMobile, getSystemSettings } from '../../../../functions/Functions';
import { BASE_URL } from '../../../../BaseUrl';
import DigitalMenuFooter from './DigitalMenuFooter';
import './CustomerInfoModal.css';
import { SettingsContext } from '../../../../contexts/Settings';

const CustomerInfoModal = ({ isOpen, onClose, orderDetail, onSave }) => {
  const { generalSettings } = useContext(SettingsContext)
  const [name, setName] = useState('');
  const [phnNo, setPhnNo] = useState('');

  const customerInfo = orderDetail?.newCustomerInfo;
  const branchName = orderDetail?.branch?.name || 'RESTAURANT';
  const tableName = orderDetail?.table?.name || 'Table';
  const coverImage = orderDetail?.branch?.cover_image ? BASE_URL + orderDetail.branch.cover_image : '/assets/img/dgmenu_cover.jpg';

  useEffect(() => {
    if (isOpen) {
      setName(customerInfo?.name || '');
      setPhnNo(customerInfo?.phn_no || '');
    }
  }, [isOpen, customerInfo]);

  const handleSave = () => {
    if (!isValidPkMobile(phnNo)) {
      return false;
    }
    onSave(name, phnNo);
    onClose();
  };


  return (
    <Modal 
      show={isOpen} 
      onHide={onClose} 
      className="customer-info-modal-wrapper"
      dialogClassName="modal-fullscreen m-0" 
      contentClassName="border-0 rounded-0"
      backdrop="static"
    >
      <div className="customer-info-page">
        {/* Header Section with Background Image */}
        <div className="customer-info-header" style={{ backgroundImage: `url(${coverImage})` }}>
          <div className="header-overlay"></div>
          <div className="header-content w-100" style={{ maxWidth: '650px' }}>
            <div className="brand-title text-white font-weight-bold mb-1">{getSystemSettings(generalSettings, "siteName")}</div>
            <div className="mt-2">
              <p className="mb-0 text-white-75 d-flex justify-content-between font-weight-bold brand-subtitle">
                RESTAURANT {branchName.toUpperCase()}
              </p>
              <h2 className="text-white font-weight-bold mt-1 mb-0 brand-welcome">Welcome to your table.</h2>
            </div>
          </div>
        </div>

        <div className="customer-info-body px-3">
          {/* Table Info Card */}
          <div className="table-info-card bg-white d-flex align-items-center">
            <div className="table-icon-box d-flex flex-column align-items-center justify-content-center text-white mr-3">
              <span className="table-label">TABLE</span>
              <span className="table-number">{tableName.replace(/[^0-9]/g, '') || tableName}</span>
            </div>
            <div>
              <div className="font-weight-bold table-info-title">You're at {tableName}</div>
              <div className="d-flex align-items-center mt-1 table-info-subtitle">
                <FaLock className="mr-1 table-info-icon" size={12} />
                <span className="font-weight-bold">Confirmed from your table's QR code</span>
              </div>
            </div>
          </div>

          {/* Customer Info Form Card */}
          <div className="customer-form-card bg-white">
            <div className="font-weight-bold mb-1 customer-form-title">Customer Info</div>
            <p className="mb-3 customer-form-subtitle">So our team knows who to serve.</p>
            
            <div className="form-group mb-3">
              <label className="customer-modal-label">Name</label>
              <div className="input-group-custom">
                <FaUser className="input-icon" color="#64748b" />
                <input 
                  type="text" 
                  className="form-control custom-input"
                  placeholder="Enter your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
            </div>
            
            <div className="form-group mb-4">
              <label className="font-weight-bold customer-modal-label">Phone Number</label>
              <div className="input-group-custom">
                <FaMobileAlt className="input-icon" color="#64748b" />
                <input 
                  type="tel" 
                  className="form-control custom-input"
                  placeholder="Enter your phone number"
                  value={phnNo}
                  onChange={(e) => setPhnNo(e.target.value)}
                />
              </div>
            </div>

            <button 
              className="btn w-100 font-weight-bold d-flex align-items-center justify-content-center save-details-btn"
              onClick={handleSave}
            >
              <span>Save Details</span>
              <FaArrowRight className="ml-2 save-btn-icon" />
            </button>
            
            <div className="text-center mt-3 font-weight-bold order-destination-text d-flex align-items-center justify-content-center">
              <FaStore className="mr-1 order-dest-icon" color="#94a3b8" /> 
              <span>Your order will be served to {tableName}.</span>
            </div>
          </div>

          {/* Browse Menu Link */}
          <div className="text-center mb-4 mt-2">
            <button className="btn modern-ghost-btn browse-menu-text d-inline-flex align-items-center justify-content-center" onClick={onClose}>
              <span className="font-weight-bold">Browse the menu first</span>
              <FaChevronRight className="ml-2 browse-menu-icon" />
            </button>
          </div>
        </div>

        {/* Footer */}
        <DigitalMenuFooter />
      </div>
    </Modal>
  );
};

export default React.memo(CustomerInfoModal);
